(function ($) {
    $(document).ready(function () {
        if ($('.reviews_slider').length) {
            $('.reviews_slider').owlCarousel({
                loop: true,
                margin: 30,
                nav: true,
                dots: false,
                autoplay: false,
                mouseDrag: false,
                touchDrag: false,
                smartSpeed: 1500,
                navText: [
                    '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7L7 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L1 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                ],
                responsive: {
                    0: {
                        items: 1,
                        touchDrag: true,
                    },
                    768: {
                        items: 2
                    },
                    1100: {
                        items: 3,
                        touchDrag: false,
                    }
                }
            });
        }
    });
})(jQuery);
